// extracted by mini-css-extract-plugin
module.exports = {"updateProjectNameModal":"UpdateProjectNameModal_updateProjectNameModal__yFpNj","checkboxLabel":"UpdateProjectNameModal_checkboxLabel__3zKLs"};